const InProgressIcon = ({ color = '#314158', width = '16px', height = '16px' }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#menu-clock-clip)">
				<path
					d="M8.00065 14.6654C11.6825 14.6654 14.6673 11.6806 14.6673 7.9987C14.6673 4.3168 11.6825 1.33203 8.00065 1.33203C4.31875 1.33203 1.33398 4.3168 1.33398 7.9987C1.33398 11.6806 4.31875 14.6654 8.00065 14.6654Z"
					stroke={color}
					strokeWidth="1.33333"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M8 4V8L10.6667 9.33333" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
			</g>
			<defs>
				<clipPath id="menu-clock-clip">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default InProgressIcon;

